import { render, staticRenderFns } from "./ModalitySelection.vue?vue&type=template&id=47da63c2"
import script from "./ModalitySelection.vue?vue&type=script&lang=js"
export * from "./ModalitySelection.vue?vue&type=script&lang=js"
import style0 from "./ModalitySelection.vue?vue&type=style&index=0&id=47da63c2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports